import type { FocusableElement } from "@react-types/shared";
import { clsx } from "clsx";
import type { CSSProperties, DOMAttributes, FC, PropsWithChildren } from "react";

import formStyle from "../../styles/form.module.css";

export interface DescriptionProps extends DOMAttributes<FocusableElement> {
  style?: CSSProperties;
  className?: string | undefined;
}

export const Description: FC<PropsWithChildren<DescriptionProps>> = (props) => {
  return props.children ? (
    <div
      data-testid="field-description"
      {...props}
      className={clsx(formStyle.description, props.className)}
      style={props.style}
    >
      {props.children}
    </div>
  ) : null;
};
